import { memo } from 'react';
import { Redirect, Route, Switch, generatePath } from 'react-router-dom';
import { LIST, BOARD, REPORT, MAP } from '../views/constants/PageType';
import { CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import IndexRoute from '../rewrite/init/components/IndexRoute';
import RestoreRoute from '../rewrite/init/components/RestoreRoute';
import getIn from 'transmute/getIn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const generateRedirectPath = ({
  objectTypeId,
  viewId,
  pageType
}) => {
  const viewString = viewId ? `/views/:viewId` : '';
  const pageTypeString = pageType ? `/:pageType` : '';
  return generatePath(`/objects/:objectTypeId${viewString}${pageTypeString}`, {
    objectTypeId,
    viewId,
    pageType
  });
};
export const handleLegacyRoute = (objectTypeId, pageType) => {
  const LegacyRoute = ({
    match,
    location
  }) => /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: generateRedirectPath({
        objectTypeId,
        viewId: getIn(['params', 'viewId'], match),
        pageType
      })
    })
  });
  return LegacyRoute;
};
const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    path: "/objects/:objectTypeId/restore",
    exact: true,
    children: /*#__PURE__*/_jsx(RestoreRoute, {})
  }), /*#__PURE__*/_jsx(Route, {
    path: ['/', '/contacts', '/contacts/list', '/contacts/view/:viewId', '/contacts/list/view/:viewId'],
    exact: true,
    children: handleLegacyRoute(CONTACT_TYPE_ID)
  }), /*#__PURE__*/_jsx(Route, {
    path: ['/companies', '/companies/list', '/companies/view/:viewId', '/companies/list/view/:viewId'],
    exact: true,
    children: handleLegacyRoute(COMPANY_TYPE_ID)
  }), /*#__PURE__*/_jsx(Route, {
    path: "/deals",
    exact: true,
    children: handleLegacyRoute(DEAL_TYPE_ID)
  }), /*#__PURE__*/_jsx(Route, {
    path: ['/deals/list', '/deals/view/:viewId', '/deals/list/view/:viewId'],
    exact: true,
    children: handleLegacyRoute(DEAL_TYPE_ID, LIST)
  }), /*#__PURE__*/_jsx(Route, {
    path: ['/deals/board', '/deals/board/view/:viewId'],
    exact: true,
    children: handleLegacyRoute(DEAL_TYPE_ID, BOARD)
  }), /*#__PURE__*/_jsx(Route, {
    path: "/tickets",
    exact: true,
    children: handleLegacyRoute(TICKET_TYPE_ID)
  }), /*#__PURE__*/_jsx(Route, {
    path: ['/tickets/list', '/tickets/view/:viewId', '/tickets/list/view/:viewId'],
    exact: true,
    children: handleLegacyRoute(TICKET_TYPE_ID, LIST)
  }), /*#__PURE__*/_jsx(Route, {
    path: ['/tickets/board', '/tickets/board/view/:viewId'],
    exact: true,
    children: handleLegacyRoute(TICKET_TYPE_ID, BOARD)
  }), /*#__PURE__*/_jsx(Route, {
    path: [`/objects/:objectTypeId/:pageType(${LIST}|${BOARD}|${REPORT}|${MAP})?`, `/objects/:objectTypeId/views/:viewId/:pageType(${LIST}|${BOARD}|${REPORT}|${MAP})?`],
    exact: true,
    children: /*#__PURE__*/_jsx(IndexRoute, {})
  }), /*#__PURE__*/_jsx(Route, {
    children: /*#__PURE__*/_jsx(Redirect, {
      to: "/objects/0-1"
    })
  })]
});
export default /*#__PURE__*/memo(Routes);